import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "required", "labelWidth", "labelStyle", "contentWidth", "contentStyle", "align", "verticalAlign", "children", "className", "style", "suffix", "suffixStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { FormGroup } from '@tencent/spaui';
var ZHB_CLS_PREFIX = 'zhb-ui';
export var ZhbFormItem = function ZhbFormItem(props) {
  var label = props.label,
    required = props.required,
    _props$labelWidth = props.labelWidth,
    labelWidth = _props$labelWidth === void 0 ? 80 : _props$labelWidth,
    labelStyle = props.labelStyle,
    contentWidth = props.contentWidth,
    contentStyle = props.contentStyle,
    _props$align = props.align,
    align = _props$align === void 0 ? 'left' : _props$align,
    _props$verticalAlign = props.verticalAlign,
    verticalAlign = _props$verticalAlign === void 0 ? 'top' : _props$verticalAlign,
    children = props.children,
    className = props.className,
    style = props.style,
    suffix = props.suffix,
    suffixStyle = props.suffixStyle,
    formGroupProps = _objectWithoutProperties(props, _excluded);
  var formClsPrefix = "".concat(ZHB_CLS_PREFIX, "-form-item");
  var labelSyl = useMemo(function () {
    return _objectSpread({
      width: labelWidth
    }, labelStyle);
  }, [labelWidth, labelStyle]);
  var contentSyl = useMemo(function () {
    return _objectSpread({
      width: contentWidth
    }, contentStyle);
  }, [contentWidth, contentStyle]);
  var labelCls = classnames(_defineProperty(_defineProperty(_defineProperty({}, "".concat(formClsPrefix, "-label"), true), "".concat(formClsPrefix, "-label-align-").concat(align), true), "".concat(formClsPrefix, "-label-vertical-align-").concat(verticalAlign), true));
  var labelNode = label && React.createElement("li", {
    className: labelCls,
    style: labelSyl
  }, required && React.createElement("span", {
    className: "".concat(formClsPrefix, "-label-required")
  }, "*\xA0"), label);
  var suffixNode = suffix && React.createElement("li", {
    className: "".concat(formClsPrefix, "-suffix"),
    style: suffixStyle
  }, suffix);
  return React.createElement("ul", {
    className: classnames(formClsPrefix, className),
    style: style
  }, labelNode, React.createElement("li", {
    className: "".concat(formClsPrefix, "-content"),
    style: contentSyl
  }, React.createElement(FormGroup, formGroupProps, children)), suffixNode);
};